var EqServerQuerySynchronizer = /** @class */ (function () {
    function EqServerQuerySynchronizer(context) {
        this.context = context;
    }
    EqServerQuerySynchronizer.prototype.syncQuery = function (options) {
        options = options || {};
        var query = options.query || this.context.getQuery();
        var ops = options.options || {};
        var requestData = {
            'query': query.toJSONData(),
            'options': ops,
        };
        if (options.data) {
            requestData.data = options.data;
        }
        var url = this.context.resolveEndpoint('SyncQuery', { modelId: query.getModel().getId(), queryId: query.getId() });
        var http = this.context.getServices().getHttpClient();
        return http.post(url, requestData)
            .then(function (responseData) { return responseData; });
    };
    return EqServerQuerySynchronizer;
}());
export { EqServerQuerySynchronizer };
//# sourceMappingURL=eqs_query_synchronizer.js.map